<template>
    <div class="login-wrap">
        <div class="ms-title">后台管理系统</div>
        <div class="ms-login">
            <el-form :model="loginInfo" :rules="loginInfoRules" ref="loginInfoForm" label-width="0px" class="demo-ruleForm">
                <el-form-item prop="username">
                    <el-input v-model="loginInfo.username" placeholder="登录名"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input type="password" placeholder="密码" v-model="loginInfo.password"></el-input>
                </el-form-item>
                <el-form-item prop="verifyCode">
                    <el-input v-model="loginInfo.verifyCode" placeholder="验证码" @keyup.enter.native="login()">
                        <img style="padding:0px;height:32px;border:0px" ref="verifyCodeImg" slot="append" src="/api/genCode" @click="genCode()"/>
                    </el-input>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" @click="login()">登录</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    export default {
        data: function(){
            return {
                loginInfo: {
                    username:null,
                    password:null,
                    verifyCode:null
                },
                loginInfoRules: {
                    username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                    password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                    verifyCode: [{ required: true, message: '请输入验证码', trigger: 'blur'}]
                }
            }
        },
        methods: {
            //登录
            async login() {
                let valid = await this.$refs.loginInfoForm.validate().catch(err=>{return Promise.resolve(false)});
                if (!valid) {
                    return;
                }
                let loading = this.$loading({lock: true, text: '登录……', spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                //登录请求需要用application/x-www-form-rulencoded提交
                this.$axios.post('/login',this.loginInfo,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    transformRequest: [function (data) {
                        let ret = ''
                        for (let it in data) {
                        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                        }
                        return ret
                    }]
                }).then(res => {
                    if (res.code === 200) {
                        this.$store.commit('updateUserInfo', res.data);
                        this.$router.replace("/");
                    } else  {
                        this.$alert(res.errMsg, '登录失败',{type:'error'});
                    }

                    if (res.code == 601 || res.code == 401) {
                        this.genCode();
                    }
                }).catch(err => {})
                .finally(()=>{
                    loading.close();
                });
            },
            genCode() {
                this.$refs.verifyCodeImg.src=`/api/genCode?time=${new Date().getTime()}`;
            }
        },

    }
</script>

<style scoped>
    .login-wrap{
        position: relative;
        width:100%;
        height:100%;
    }
    .ms-title{
        position: absolute;
        top:50%;
        width:100%;
        margin-top: -230px;
        text-align: center;
        font-size:30px;
        color: #fff;

    }
    .ms-login{
        position: absolute;
        left:50%;
        top:50%;
        width:300px;
        /* height:160px; */
        margin:-150px 0 0 -190px;
        padding:40px;
        border-radius: 5px;
        background: #fff;
    }
    .login-btn{
        text-align: center;
    }
    .login-btn button{
        width:100%;
        height:36px;
    }

</style>
<style>
    .el-input-group__append, .el-input-group__prepend {
        padding: 0px;
        border:0px;
    }
</style>
